import PageHeaderCR from './PageHeaderCR';

export default PageHeaderCR;
